import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-prp.jpg";
import heroImage1 from "../../../assets/images/ad-prp1.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/wrinkles-reduction.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  'ACNE': acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  'YOUTH': youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

// Location data for SEO purposes only
const locations = {
  tambaram: {
    name: "Tambaram",
    address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
    popularServices: [
      "PRP Facial Rejuvenation",
      "PRP for Fine Lines",
      "Collagen Induction Therapy with PRP",
      "Natural Skin Rejuvenation"
    ],
    specialties: "PRP Face Treatment & Anti-Aging",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai"
  },
  valasaravakkam: {
    name: "Valasaravakkam",
    address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
    popularServices: [
      "PRP for Skin Texture",
      "PRP for Hyperpigmentation",
      "Youthful Glow with PRP",
      "Non-Invasive PRP Facial"
    ],
    specialties: "PRP Treatments & Skin Renewal",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai"
  },
  gerugambakkam: {
    name: "Gerugambakkam",
    address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
    popularServices: [
      "Advanced PRP Face Therapy",
      "PRP for Acne Scars",
      "Skin Tightening with PRP",
      "Customized PRP Treatment"
    ],
    specialties: "Complete PRP Face Solutions",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai"
  },
  jayanagar: {
    name: "Jayanagar Bangalore",
    address: "Jayanagar, Bengaluru, Karnataka 560069",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh",
    popularServices: [
      "PRP Face Treatment Bangalore",
      "PRP for Wrinkle Reduction",
      "PRP for Skin Glow",
      "Dermatologist PRP Face Treatment"
    ],
    specialties: "Advanced PRP Face & Dermatology Treatments",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Jayanagar+Bangalore"
  }
};

// Define the gallery images
const images = [
  { src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80", alt: "Before and After PRP Face Results" },
  { src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80", alt: "PRP Face Procedure Close-Up" },
  { src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80", alt: "Advanced PRP Face Equipment" },
];

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("PRP FACE");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>Innovative PRP Face Solutions</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Prpface() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);
  
  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best PRP Face Treatment in Chennai, Bangalore | Skin Rejuvenation Therapy Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Best PRP Face treatment in Chennai, Bangalore. Advanced platelet-rich plasma therapy, collagen stimulation, and wrinkle reduction solutions. Professional dermatological services at H-Cura clinic locations across Chennai Tamil Nadu and Bangalore Karnataka including Tambaram, Valasaravakkam, Gerugambakkam, Jayanagar areas."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "PRP face treatment Chennai, platelet-rich plasma Bangalore, PRP face clinic Tamil Nadu, dermatologist Karnataka, collagen stimulation Chennai Bangalore, PRP face specialist Tamil Nadu Karnataka, best PRP clinic Chennai Bangalore, PRP treatment near me, PRP facial rejuvenation Tambaram Valasaravakkam Gerugambakkam Jayanagar, dermatology clinic Chennai Bangalore, PRP for fine lines Tamil Nadu Karnataka, PRP for skin texture Chennai Bangalore, PRP for hyperpigmentation specialist Chromepet Pallavaram Perungalathur Koramangala BTM Layout JP Nagar, advanced PRP face therapy Porur Alwarthirunagar Virugambakkam Banashankari Basavanagudi, youthful glow with PRP Kundrathur Mangadu Poonamallee Wilson Garden Lalbagh, non invasive PRP facial Chennai Bangalore, PRP for acne scars Tamil Nadu Karnataka, skin tightening with PRP Chennai Bangalore, customized PRP treatment Tamil Nadu Karnataka, PRP for wrinkle reduction Tambaram Jayanagar, PRP for skin glow Valasaravakkam Koramangala, dermatologist PRP face treatment Gerugambakkam BTM Layout, PRP skin rejuvenation Chennai Bangalore, professional PRP face treatment Tamil Nadu Karnataka, PRP face services Chennai Bangalore, PRP face doctor Tamil Nadu Karnataka, PRP face treatment center Chennai Bangalore, dermatology Chennai Bangalore, PRP face skincare clinic Tamil Nadu Karnataka, PRP face consultation Chennai Bangalore, PRP face skin analysis Tamil Nadu Karnataka, PRP face treatment prevention Chennai Bangalore, PRP face skin health Tamil Nadu Karnataka, dermatological PRP face treatment Chennai Bangalore, cosmetic PRP face dermatology Tamil Nadu Karnataka, medical PRP face skincare Chennai Bangalore, professional PRP face treatment Tamil Nadu Karnataka, PRP face skin wellness Chennai Bangalore, PRP face dermatology services Tamil Nadu Karnataka, PRP face treatment Tambaram Gandhi Road Jayanagar, PRP face clinic Valasaravakkam Krishnamachari Nagar Koramangala, PRP face dermatologist Gerugambakkam Ramachandra Nagar BTM Layout, PRP face doctor Chromepet Pallavaram JP Nagar Banashankari, PRP face skin treatment Porur Alwarthirunagar Basavanagudi Wilson Garden, PRP face treatment clinic Virugambakkam Kundrathur Lalbagh, PRP face rejuvenation treatment Mangadu Poonamallee Bangalore"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced PRP Face and skin rejuvenation treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-prp-face-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        {
          "@type": "State",
          "name": "Tamil Nadu"
        },
        {
          "@type": "State",
          "name": "Karnataka"
        },
        {
          "@type": "State",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Chennai"
        },
        {
          "@type": "City",
          "name": "Bangalore"
        },
        {
          "@type": "City",
          "name": "Bengaluru"
        },
        {
          "@type": "City",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Puducherry"
        },
        // Chennai Areas
        {
          "@type": "City",
          "name": "Tambaram"
        },
        {
          "@type": "City",
          "name": "Valasaravakkam"
        },
        {
          "@type": "City",
          "name": "Gerugambakkam"
        },
        {
          "@type": "City",
          "name": "Chromepet"
        },
        {
          "@type": "City",
          "name": "Pallavaram"
        },
        {
          "@type": "City",
          "name": "Perungalathur"
        },
        {
          "@type": "City",
          "name": "Porur"
        },
        {
          "@type": "City",
          "name": "Alwarthirunagar"
        },
        {
          "@type": "City",
          "name": "Virugambakkam"
        },
        {
          "@type": "City",
          "name": "Kundrathur"
        },
        {
          "@type": "City",
          "name": "Mangadu"
        },
        {
          "@type": "City",
          "name": "Poonamallee"
        },
        // Bangalore Areas
        {
          "@type": "City",
          "name": "Jayanagar"
        },
        {
          "@type": "City",
          "name": "Koramangala"
        },
        {
          "@type": "City",
          "name": "BTM Layout"
        },
        {
          "@type": "City",
          "name": "JP Nagar"
        },
        {
          "@type": "City",
          "name": "Banashankari"
        },
        {
          "@type": "City",
          "name": "Basavanagudi"
        },
        {
          "@type": "City",
          "name": "Wilson Garden"
        },
        {
          "@type": "City",
          "name": "Lalbagh"
        }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "PRP Face Treatment",
        "Skin Rejuvenation",
        "Collagen Stimulation",
        "Wrinkle Reduction",
        "Facial Rejuvenation",
        "Platelet-Rich Plasma Therapy"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "PRP Face Treatment Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced PRP Face Treatment"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "PRP Facial Rejuvenation"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "PRP for Fine Lines"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Collagen Induction Therapy with PRP"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "PRP for Skin Texture Improvement"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "PRP for Hyperpigmentation"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "PRP for Acne Scars"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent PRP face treatment at H-Cura Jayanagar. Professional staff and amazing results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best PRP skin rejuvenation treatment in Chennai Tambaram. Highly recommend H-Cura clinic."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing PRP face treatment results at H-Cura. Professional and caring staff."
        }
      ]
    };

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best PRP Face Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced PRP Face treatment and skin rejuvenation solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional dermatological services for youthful, radiant skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-prp-face-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best PRP Face Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced PRP Face treatment and skin rejuvenation solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "PRP Face Treatment, Skin Rejuvenation, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-prp-face-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-prp-face-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "PRP Face Treatment",
          "item": "https://www.h-cura.com/advanced-prp-face-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for PRP Face treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides PRP Face treatment services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of PRP Face treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Advanced PRP Face Treatment, PRP Facial Rejuvenation, PRP for Fine Lines, Collagen Induction Therapy with PRP, PRP for Skin Texture Improvement, PRP for Hyperpigmentation, and PRP for Acne Scars across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for PRP Face treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        },
        {
          "@type": "Question",
          "name": "What is PRP Face treatment and how does it work?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "PRP (Platelet-Rich Plasma) Face treatment uses your body's own growth factors to stimulate collagen production and rejuvenate your skin. A small amount of blood is drawn, processed to concentrate platelets, and then injected or microneedled into the face to promote healing and regeneration."
          }
        },
        {
          "@type": "Question",
          "name": "What results can I expect after a PRP Face treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can expect improved skin texture and tone, reduced fine lines and wrinkles, enhanced collagen production, and a more youthful, radiant complexion. Results typically become visible a few weeks after treatment and continue to improve over time."
          }
        },
        {
          "@type": "Question",
          "name": "Is PRP Face treatment safe?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, PRP Face treatment is generally considered safe as it uses your body's own blood, minimizing the risk of allergic reactions or adverse side effects. Our trained professionals ensure a sterile and safe procedure."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Add preconnect for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-prp-face-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-prp-face-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const openModal = (image) => {
    const index = images.findIndex(img => img.src === image.src);
    setCurrentImageIndex(index);
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const navigatePrevious = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateNext = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateGalleryPrev = () => {
    if (visibleGalleryImages[0] > 0) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx - 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  const navigateGalleryNext = () => {
    if (visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx + 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;
      
      if (e.key === 'ArrowLeft') {
        navigatePrevious(e);
      } else if (e.key === 'ArrowRight') {
        navigateNext(e);
      } else if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isModalOpen, currentImageIndex]);

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
      <section
        className="ads-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="ads-hero-content">
          <h1 className="ads-hero-title">
            Innovative PRP Face Solutions for Radiant Skin
          </h1>
          <p className="ads-hero-text">
            Experience cutting-edge PRP face therapies designed to rejuvenate, and transform your skin.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with PRP Face Treatment</h2>
            <p className="ads-nav-description">
              Our PRP face treatment combines advanced platelet-rich plasma technology with nourishing
              ingredients for optimal skin health.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>PRP FACIAL REJUVENATION</strong>
                <p>Stimulates collagen production for overall facial renewal.</p>
                <ul className="ads-treatment-details">
                  <li>Improves Skin Texture and Tone</li>
                  <li>Reduces Fine Lines and Wrinkles</li>
                  <li>Promotes Youthful Radiance</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>PRP FOR FINE LINES</strong>
                <p>Targets and reduces the appearance of fine lines.</p>
                <ul className="ads-treatment-details">
                  <li>Smooths Expression Lines</li>
                  <li>Enhances Skin Elasticity</li>
                  <li>Non-Invasive Solution</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>COLLAGEN INDUCTION THERAPY WITH PRP</strong>
                <p>Boosts natural collagen for firmer, younger-looking skin.</p>
                <ul className="ads-treatment-details">
                  <li>Increases Skin Firmness</li>
                  <li>Improves Skin Density</li>
                  <li>Long-Lasting Benefits</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>PRP FOR HYPERPIGMENTATION</strong>
                <p>Evens out skin tone and reduces dark spots.</p>
                <ul className="ads-treatment-details">
                  <li>Treats Sun Damage</li>
                  <li>Brightens Complexion</li>
                  <li>Reduces Discoloration</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>PRP FOR ACNE SCARS</strong>
                <p>Promotes healing and reduces the appearance of acne scars.</p>
                <ul className="ads-treatment-details">
                  <li>Minimizes Scarring</li>
                  <li>Improves Skin Smoothness</li>
                  <li>Enhances Skin Regeneration</li>
                </ul>
              </li>
            </ul>

            <p className="ads-treatment-description-text">
              Our PRP Face treatments are customized for each individual's skin
              type and concerns.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of PRP Face treatment.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3>Innovative PRP Face Treatment Overview</h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="Innovative PRP Face Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  <button 
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: -gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryPrev();
                    }}
                    aria-label="Previous image"
                    style={{display: visibleGalleryImages[0] > 0 ? 'block' : 'none'}}
                  >
                    &#10094;
                  </button>
                  <button 
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryNext();
                    }}
                    aria-label="Next image"
                    style={{display: visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1 ? 'block' : 'none'}}
                  >
                    &#10095;
                  </button>
                </div>
                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span 
                      key={index} 
                      className={`ads-gallery-dot ${visibleGalleryImages.includes(index) ? 'active' : ''}`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h4>Empowering Innovative PRP Face Solutions</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">
                   INNOVATIVE PRP FACE TREATMENT
                  </span>
                  <p className="ads-lead-text">
                    Our breakthrough PRP face treatments use your body's natural healing
                    mechanisms to rejuvenate and renew your skin.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of Our PRP Face Treatments</h5>
                  <p>Enjoy benefits such as:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Anti-Aging" />
                      </span>{" "}
                      <strong>Anti-Aging</strong>
                      <p>Reduced fine lines and wrinkles for a youthful look</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Suitable for All Skin"
                        />
                      </span>{" "}
                      <strong>Suitable for All Skin Types</strong>
                      <p>Safe and effective for diverse skin conditions</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Fair and Glowing Skin"
                        />
                      </span>{" "}
                      <strong>Fair and Glowing Skin</strong>
                      <p>Treats hyperpigmentation for an even, radiant complexion</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Effective and Painless"
                        />
                      </span>{" "}
                      <strong>Effective and Minimally Invasive</strong>
                      <p>
                        Achieve noticeable results with minimal discomfort and downtime.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>60 mins</p>
                    <span className="ads-subtitle">Per Treatment</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Progressive Results</p>
                    <span className="ads-subtitle">Quick Recovery</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced PRP Face treatments combine clinical expertise with innovative
            technology to restore your skin's natural beauty.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in PRP face treatment technology for precise and effective results.",
              features: [
                "Innovative protocols",
                "FDA-approved methods",
                "Clinically proven outcomes",
              ],
            },
            {
              icon: "👨‍⚕️",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists provide personalized care tailored to your skin.",
              features: [
                "Highly experienced professionals",
                "Individual consultations",
                "Focused attention to detail",
              ],
            },
            {
              icon: "🎯",
              title: "Customized Therapy",
              desc: "Every treatment plan is designed specifically for your skin type and concerns.",
              features: [
                "Tailored sessions",
                "Ongoing progress monitoring",
                "Optimized treatment frequency",
              ],
            },
            {
              icon: "✨",
              title: "Natural-Looking Results",
              desc: "Achieve visible, natural skin improvement with our gentle, effective treatments.",
              features: [
                "Subtle enhancements",
                "Long-lasting benefits",
                "Effortless aesthetics",
              ],
            },
            {
              icon: "🛡️",
              title: "Safety First",
              desc: "We maintain the highest standards of safety and hygiene in our treatment facilities.",
              features: [
                "Medical-grade environment",
                "Strict protocols",
                "Patient-centric care",
              ],
            },
            {
              icon: "💯",
              title: "Proven Success",
              desc: "Join thousands of happy clients who have transformed their skin with our solutions.",
              features: [
                "Over 5000 satisfied clients",
                "Remarkable clinical outcomes",
                "Consistently high success rates",
              ],
            },
          ].map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Radiant, Rejuvenated Skin with PRP Face</h2>
          <p className="ads-process-subtitle">
            Follow our comprehensive 4-step approach for sustainable PRP face
            rejuvenation.
          </p>
        </div>
        <div className="ads-process-timeline">
          {[
            {
              step: "01",
              title: "In-Depth Consultation",
              desc: "Kick off your journey with a thorough consultation to assess your skin and PRP treatment needs.",
              details: [
                "Detailed skin analysis",
                "Personal health review",
                "Customized treatment roadmap",
                "Expectation setting",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Tailored Treatment Planning",
              desc: "Our specialists design a personalized PRP face treatment plan just for you.",
              details: [
                "Individualized regimen design",
                "Blood sample collection & processing",
                "Session scheduling",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Expert PRP Face Session",
              desc: "Experience our precise techniques for targeted and effective PRP face treatment.",
              details: [
                "Sterile preparation",
                "Precise PRP application (injection/microneedling)",
                "Targeted skin regeneration",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Benefit from our dedicated follow-up care ensuring your skin remains at its best.",
              details: [
                "Routine progress reviews",
                "Adaptive treatment adjustments",
                "Maintenance plans",
                "Long-term support",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">{process.desc}</p>
                  <ul className="ads-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best PRP Face Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>PRP Face Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced PRP Face treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur areas with PRP Facial Rejuvenation, PRP for Fine Lines, Collagen Induction Therapy with PRP, Natural Skin Rejuvenation. 
          Specializing in PRP Face Treatment & Anti-Aging. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best PRP face treatment Tamil Nadu, PRP face specialist Chennai, PRP dermatologist Tambaram, PRP clinic Chromepet, PRP treatment Pallavaram, collagen induction therapy Perungalathur.
        </p>
        
        <h3>PRP Face Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional PRP Face services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam communities with PRP for Skin Texture, PRP for Hyperpigmentation, Youthful Glow with PRP, Non-Invasive PRP Facial. 
          Specializing in PRP Treatments & Skin Renewal. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          PRP face treatment Valasaravakkam, PRP clinic Porur, PRP dermatologist Alwarthirunagar, PRP face specialist Virugambakkam, PRP skin rejuvenation Chennai Tamil Nadu.
        </p>
        
        <h3>Complete PRP Face Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive PRP Face treatment services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee residents with Advanced PRP Face Therapy, PRP for Acne Scars, Skin Tightening with PRP, Customized PRP Treatment. 
          Offering Complete PRP Face Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          PRP face treatment Gerugambakkam, PRP clinic Kundrathur, PRP dermatologist Mangadu, PRP face specialist Poonamallee, PRP skin rejuvenation Chennai Tamil Nadu.
        </p>

        <h3>Advanced PRP Face Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier PRP Face and skin rejuvenation services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh areas with PRP Face Treatment Bangalore, PRP for Wrinkle Reduction, PRP for Skin Glow, Dermatologist PRP Face Treatment. 
          Specializing in Advanced PRP Face & Dermatology Treatments. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best PRP face treatment Bangalore, PRP face specialist Karnataka, PRP dermatologist Jayanagar, PRP clinic Koramangala, PRP treatment BTM Layout, collagen induction therapy JP Nagar, 
          PRP face doctor Banashankari, PRP skin rejuvenation Basavanagudi, PRP dermatology Wilson Garden, PRP face treatment Lalbagh, PRP clinic Bangalore Karnataka, PRP face specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides PRP Face treatment and skin rejuvenation services across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          PRP face treatment Bangalore, platelet-rich plasma Karnataka, PRP dermatologist Bengaluru, PRP face clinic Bangalore, PRP face specialist Karnataka, PRP facial rejuvenation Bangalore, 
          PRP for fine lines Karnataka, collagen induction therapy with PRP Bangalore, PRP for skin texture Karnataka, PRP for hyperpigmentation Bangalore, PRP for acne scars Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides PRP Face treatment and skin rejuvenation services across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          PRP face treatment Chennai, platelet-rich plasma Tamil Nadu, PRP dermatologist Chennai, PRP face clinic Tamil Nadu, PRP face specialist Chennai, PRP facial rejuvenation Tamil Nadu.
        </p>

        <h3>Advanced PRP Face Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive PRP Face treatment including Advanced PRP Face Treatment, PRP Facial Rejuvenation, PRP for Fine Lines, 
          Collagen Induction Therapy with PRP, PRP for Skin Texture Improvement, PRP for Hyperpigmentation, PRP for Acne Scars, 
          Youthful Glow with PRP, and Non-Invasive PRP Facial.
          Best PRP face treatment Chennai Bangalore, PRP face specialist Tamil Nadu Karnataka, PRP dermatologist Chennai Bangalore, PRP face clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert PRP Face Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified PRP face dermatologists and PRP face specialists providing personalized PRP face treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          PRP face specialist Chennai Bangalore, PRP dermatologist Tamil Nadu Karnataka, PRP face doctor Chennai Bangalore, PRP treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          PRP face treatment near me, platelet-rich plasma near me, dermatologist near me, PRP face clinic near me, collagen stimulation near me, best PRP face treatment, 
          professional PRP face, PRP face doctor, PRP skin clinic, PRP dermatology clinic, PRP facial rejuvenation, PRP for fine lines, collagen induction therapy with PRP, PRP for skin texture, 
          PRP for hyperpigmentation, PRP for acne scars, youthful glow with PRP, non invasive PRP facial, skin tightening with PRP, customized PRP treatment, 
          cosmetic PRP face dermatology, medical PRP face skincare, PRP face skin health, PRP face consultation, PRP face skin analysis, PRP face treatment prevention, dermatological PRP face treatment, 
          PRP face skin wellness, PRP face therapy, PRP face skin problem solutions, PRP for wrinkle reduction, PRP for skin glow, 
          PRP face specialist doctor, professional PRP face care, advanced PRP face treatment, innovative PRP face solutions, PRP face skin transformation, 
          youthful PRP face treatment, radiant PRP face therapy, PRP face skin renewal, PRP face management, PRP for all skin types, 
          non-invasive PRP face treatment, safe PRP face treatment, effective PRP face care, proven PRP face solutions, personalized PRP face treatment, 
          customized PRP face therapy, expert PRP face care, quality PRP dermatology services, trusted PRP face clinic, reliable PRP face treatment, 
          affordable PRP face care, convenient PRP dermatology, accessible PRP face treatment, comprehensive PRP face solutions.
        </p>
      </div>

      {/* Modal for Image Viewing with Navigation */}
      {isModalOpen && (
        <div className="ads-modal-overlay" onClick={closeModal}>
          <div className="ads-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ads-close-modal" onClick={closeModal}>
              &times;
            </button>
            <button 
              className="ads-modal-nav ads-modal-prev" 
              onClick={navigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button 
              className="ads-modal-nav ads-modal-next" 
              onClick={navigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Prpface;
